import PaymentBubble from '../PaymentBubble';
import { PaymentBubbleCommonProps } from '../types';

export default function InduceManufacturingCompletionBubble({
  history
}: PaymentBubbleCommonProps) {
  const onClickButton = () => {
    if (!history) return;
    const { pathname } = history.location;
    history.push(`${pathname}?menu=purchaseorder`);
  };

  return (
    <PaymentBubble>
      <PaymentBubble.Title>구매확정 대기중입니다.</PaymentBubble.Title>
      <PaymentBubble.Stepper activeStep={3} />
      <PaymentBubble.Content>
        제품 검품 후 이상이 없다면 구매확정하여 거래를 완료해주세요.
      </PaymentBubble.Content>
      <PaymentBubble.Button buttonAction={onClickButton}>
        제조현황 확인
      </PaymentBubble.Button>
    </PaymentBubble>
  );
}
